import DocumentBrowser from "../../components/DocumentBrowser/DocumentBrowser";
import Menu from "../../components/Menu/Menu";

function DataCatalogue() {
    const menuItems = [
        {
          name: "Home",
          link: "/",
        },
        {
          name: "Dashboard",
          link: "/dashboard",
        },
        {
          name: "Data Catalogue",
          link: "/data-catalogue",
        },
      ];
  return (
    <>
      <Menu menuItems={menuItems}></Menu>
      <DocumentBrowser containerName={"dev-medinfo"} className="mt-4" />
    </>
  );
}
export default DataCatalogue;
